import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { Table } from "../../../common/components/core";
import { ResponseWithPagination } from "../../../types/common";
import { Profile } from "../ProfileDetailView";
import {
    generateProfileLocationDisplayName,
    generateTypeDisplayName,
} from "../ProfileManageMentView";

type ProfileTableProps = {
    // data: Profile[];
    profiles: ResponseWithPagination<Profile[]>;
    nextPage: () => void;
    prevPage: () => void;
    toPage: (page: number) => void;
};

const StyledTd = styled.td`
    vertical-align: top;
`;
export const ProfileTable = ({ profiles, nextPage, prevPage, toPage }: ProfileTableProps): JSX.Element => {
    const history = useHistory();
    const handleClickRow = (data: Profile) => {
        const userProfileId = data.id;
        if (userProfileId) {
            history.push(`/profile-management/profile-information/${data.id}`);
        }
    };
    return (
        <>
            <table className="custom-table">
                <thead>
                    <tr>
                        <Table.HeaderCell width={240}>
                            Profile Name
                        </Table.HeaderCell>
                        <Table.HeaderCell width={180}>
                            Profile Country & City
                        </Table.HeaderCell>
                        <Table.HeaderCell width={180}>
                            Profile Type
                        </Table.HeaderCell>
                        <Table.HeaderCell width={344}>
                            Contact Person Email Address{" "}
                        </Table.HeaderCell>
                    </tr>
                </thead>
                <tbody>

                    {profiles.content.map((data, index) => {
                        return (
                            <Table.BodyRow
                                key={index}
                                onClick={() => handleClickRow(data)}
                                onKeyUp={(event:KeyboardEvent) =>
                                    {(event.keyCode === 13 || event.keyCode === 32) &&
                                        handleClickRow(data);
                                    }
                                }
                            >
                                <StyledTd className="cta-cell">
                                    {data.profileName}
                                </StyledTd>
                                <StyledTd>
                                    {generateProfileLocationDisplayName(
                                        data.profileCountryCity,
                                    )}
                                </StyledTd>
                                <StyledTd>
                                    {generateTypeDisplayName(data.profileType)}
                                </StyledTd>
                                <StyledTd>{data.contactPersonEmail}</StyledTd>
                            </Table.BodyRow>
                        );
                    })}

                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={4}>
                            <Table.Pagination
                                backArrowOnClick={prevPage}
                                nextArrowOnClick={nextPage}
                                backArrowDisabled={profiles.first}
                                nextArrowDisabled={profiles.last}
                                totalPage={profiles.totalPages}
                                currentPage={profiles.number + 1}
                                onPageNumberChange={(page) => toPage(page - 1)}
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </>
    );
};
